var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"location-service-icon",class:{
    'location-service-icon_active': _vm.isActive,
  }},[_c('div',{staticClass:"location-service-icon__image"},[_c('img',{attrs:{"src":_vm.icon,"alt":_vm.label}})]),_c('div',{staticClass:"location-service-icon__label"},[_vm._v(" "+_vm._s(_vm.label)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }